// 
// Dark / Light mode toggle switch
// Selection is stored in LocalStorage on browser key "theme" with value toggled

$(document).ready(function($) {


    function calculateSettingAsThemeString({ localStorageTheme, systemSettingDark }) {

        if (localStorageTheme !== null) {
          return localStorageTheme;
        }
      
        if (systemSettingDark.matches) {
          return "dark";
        }
        return "light";
      }
      
      // Updating the Toggle (toggling CHECKED status)
      function updateButton({ buttonEl, isDark }) {
        var toggleMode = $("#modetoggle");

        const newCta = isDark ? "Change to light theme" : "Change to dark theme";
        const newChecked = isDark ? true : false;
        
        buttonEl.setAttribute("aria-label", newCta);
        toggleMode.prop('checked', newChecked);
        buttonEl.innerText = newCta;
      }
      
      // Updating the Data-Theme attribute on BODY tag 

      function updateThemeOnBodyEl({ theme }) {
        document.querySelector("body").setAttribute("data-theme", theme);
      }
      
      
      const button = document.querySelector("[data-theme-toggle]");
      const localStorageTheme = localStorage.getItem("theme");
      const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");
      
      let currentThemeSetting = calculateSettingAsThemeString({ localStorageTheme, systemSettingDark });
      
      updateButton({ buttonEl: button, isDark: currentThemeSetting === "dark" });
      updateThemeOnBodyEl({ theme: currentThemeSetting });
      
      button.addEventListener("click", (event) => {
        const newTheme = currentThemeSetting === "dark" ? "light" : "dark";
      
        localStorage.setItem("theme", newTheme);
        updateButton({ buttonEl: button, isDark: newTheme === "dark" });
        updateThemeOnBodyEl({ theme: newTheme });
      
        currentThemeSetting = newTheme;
      }); 
    });